module.exports = ".subscriberdiv{\n  height:40vh;\n  width: 40vh;\n  border: 5px solid;\n}\n\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/visio/subscriber/subscriber.component.css
// module id = ./src/app/visio/subscriber/subscriber.component.css
// module chunks = main